import { render, staticRenderFns } from "./source-company.vue?vue&type=template&id=6a56bd76&"
import script from "./source-company.vue?vue&type=script&lang=js&"
export * from "./source-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a56bd76')) {
      api.createRecord('6a56bd76', component.options)
    } else {
      api.reload('6a56bd76', component.options)
    }
    module.hot.accept("./source-company.vue?vue&type=template&id=6a56bd76&", function () {
      api.rerender('6a56bd76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion/source-company.vue"
export default component.exports